import { useEffect, useState } from 'react'
import cn from 'classnames'

import { ContentSteps } from 'src/lib/useStepFlow'
import Ticket from 'src/icons/ticket.webp'
import Ron from 'src/icons/ron.webp'
import Euro from 'src/icons/euro.webp'
import { TLang } from 'src/constants/langs'
import { useLocalizedText } from 'src/shared/utils/use-localized-text/useLocalizedText'

import { texts } from './text-third-step'

import styles from './styles.module.scss'

type TProps = {
    onNext: (step: ContentSteps) => void
    step: ContentSteps
    lang: TLang
}

export const ThirdStep = ({ onNext, step, lang }: TProps) => {
    const { header } = useLocalizedText(lang, texts)
    const [stopPulse, setStopPulse] = useState<{ [key: number]: boolean }>({
        0: false,
        1: false,
        2: false,
    })
    const [isLocked, setIsLocked] = useState(false)

    const imageByLang = lang === 'ro' ? lang : 'en'

    const handleCardClick = (index: number) => {
        if (isLocked || stopPulse[index]) return

        setStopPulse((prev) => ({
            ...prev,
            [index]: true,
        }))
    }

    useEffect(() => {
        const trueCount = Object.values(stopPulse).filter((v) => v).length

        if (trueCount === 2) {
            setIsLocked(true)
            const timeout = setTimeout(() => {
                onNext(step)
            }, 1000)
            return () => clearTimeout(timeout)
        }
    }, [stopPulse, onNext, step])

    return (
        <div className={styles.root}>
            <div className={styles.text_wrapper}>{header}</div>
            <div
                className={cn(styles.tickets_wrapper, {
                    [styles[`tickets_wrapper--${lang}`]]: lang === 'ro',
                })}
            >
                {Array.from({ length: 3 }).map((_, index) => (
                    <div
                        key={index}
                        onClick={
                            !stopPulse[index]
                                ? () => handleCardClick(index)
                                : undefined
                        }
                        className={cn(
                            styles.ticket_wrapper,
                            styles.ticket_pulse,
                            {
                                [styles.stop_ticket_pulse]: stopPulse[index],
                            }
                        )}
                    >
                        <img
                            src={Ticket}
                            alt="Ticket"
                            className={cn(styles.ticket)}
                        />

                        <div
                            className={cn(
                                styles.ticket_wrapper__blur,
                                stopPulse[index]
                                    ? styles.visible
                                    : styles.hidden
                            )}
                        />

                        <img
                            src={imageByLang === 'ro' ? Ron : Euro}
                            alt={`Currency__${imageByLang}`}
                            className={cn(
                                styles.currency,
                                styles[`currency__${imageByLang}`],
                                stopPulse[index]
                                    ? styles.visible
                                    : styles.hidden
                            )}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}
